import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import { StringExtensions } from "../../../../_helpers/extensions";
import { useEffect, useRef, useState } from "react";
import { MultiSelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/MultiSearcher";
import { servicesActions } from "../../../../_store/services.slice";

export function ServicesMultiSelect({ name, optionSave, required, isAddressIdRequired = false, addressId, resetOnReadonlyChange, skipFieldsTrack, editHelperName, transactionType, skipInitLoading = false }) {
  const dispatch = useDispatch();
  const { getValues } = useFormContext();
  const servicesEditHelperName = StringExtensions.extractObjectBeforeLastProperty(name);
  const servicesEditHelper = getValues(`${servicesEditHelperName}.${editHelperName}`);
  const isFirstRender = useRef(true);
  const [items, setItems] = useState([]);

  const onSearchChange = async(searchTerm) => {
    const params = {
      searchQuery: searchTerm,
      pageNumber: 1,
      pageSize: 10,
      customFilters: { addressId: addressId, transactionType: transactionType }
    };
    const { payload } = await dispatch(servicesActions.search(params));
    setItems(payload?.items ?? []);
  };

  useEffect(() => {
    if (isFirstRender.current && skipInitLoading) {
      isFirstRender.current = false;
      return;
    }
    onSearchChange(null);
  }, [addressId, transactionType]); // eslint-disable-next-line/react-hooks/exhaustive-deps

  return (
    <>
      <MultiSelectSearcher
        name={name}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "serviceId", value: "name" }}
        optionSave={(x) => (optionSave ? optionSave(x) : x.serviceId)}
        placeholder="Wybierz usługi"
        editHelper={servicesEditHelper}
        required={required}
        bg="info"
        readonly={isAddressIdRequired && !addressId}
        resetOnReadonlyChange={resetOnReadonlyChange}
        skipFieldsTrack={skipFieldsTrack}
      />
    </>
  );
}